export const COMPANY = 'Merry Widow Insurance Co.'
export const PRIVACY_POLICY_URL = 'http://example.com/privacy_policy'
export const LOCAL_SALES_AGENT_URL = 'http://example.com/find_sales_office'
export const LIFE_INSURANCE_PRODUCTS_URL = 'http://example.com/life_insurance_products'



/** WEBPACK FOOTER **
 ** C:/repos/lifequote-github/src/constants.js
 **/